// removed by extract-text-webpack-plugin
module.exports = {"miniChart":"miniChart___3rXEh"};


//////////////////
// WEBPACK FOOTER
// /Applications/MAMP/htdocs/www/alipay-cd/project/antd-pro/antd-pro/scaffold/src/components/Charts/index.less
// module id = 137
// module chunks = 0 1